import { makeStyles, tokens } from '@fluentui/react-components';

export const useDailyHabitsIconStyles = makeStyles({
  container: {
    width: tokens.fontSizeBase600,
    height: tokens.fontSizeBase600,
  },
  icon: {
    '& > svg': {
      width: tokens.fontSizeBase500,
      height: tokens.fontSizeBase500,
    },
  },
});
